module.exports = __webpack_public_path__ + "static/media/Newt-Scamander.1d7db99a.png";